import API from 'services/api';

import { IICalAdd } from '../models';

export const postImportICal = ({ unitId, payload }: { unitId: string; payload: IICalAdd }) =>
  API.post(`/api/accommodation/iCal/units/${unitId}`, payload);
